import { Injectable } from '@angular/core';
import { DialogInfo } from '../models/dialogInfo';

@Injectable({
  providedIn: 'root',
})
export class DialogInfoService {
  constructor() {}

  public loadDialogInfo(dialogInfoXml: string): DialogInfo {
    // Load dialog information logic here
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(dialogInfoXml, 'text/xml');

    // Extract relevant information from the XML
    const dialogInfo = new DialogInfo();
    dialogInfo.state = xmlDoc.getElementsByTagName('dialog-info')[0]?.getAttribute('state') || '';

    dialogInfo.dialogs = Array.from(xmlDoc.getElementsByTagName('dialog')).map(dialog => {
      let state = dialog.getElementsByTagName('state')[0]?.textContent || '';

      return {
        eveCallId: dialog.getAttribute('call-id') || '',

        localDisplayName: dialog.querySelector('local identity')?.getAttribute('display-name') || '',
        localUri: dialog.querySelector('local identity')?.textContent || '',

        remoteDisplayName: state == "confirmed" ? dialog.querySelector('referred-by')?.getAttribute('display-name') || '' : dialog.querySelector('remote identity')?.getAttribute('display-name') || '',
        remoteUri: state == "confirmed" ? dialog.querySelector('referred-by')?.textContent || '':dialog.querySelector('remote identity')?.textContent || '',

        localTag: dialog.getAttribute('local-tag') || '',
        remoteTag: dialog.getAttribute('remote-tag') || '',
        state: dialog.getElementsByTagName('state')[0]?.textContent || '',
        
        
      };
    });

    return dialogInfo;
  }
}
